module.exports = __webpack_public_path__ + "img/nv24_bg.fca1c475.png";